export default __webpack_public_path__ + "static/media/sassi.3e5e5fb8.png";